import { render, staticRenderFns } from "./InputTags.vue?vue&type=template&id=607137bf&scoped=true"
import script from "./InputTags.vue?vue&type=script&lang=js"
export * from "./InputTags.vue?vue&type=script&lang=js"
import style0 from "./InputTags.vue?vue&type=style&index=0&id=607137bf&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607137bf",
  null
  
)

export default component.exports